import React from 'react';
import { HeaderMainNavigation } from './HeaderMainNavigation';
import { __ } from '../../../../utils/translation-service';
import { IHeaderContentItems } from '../interface';

export const HeaderMainNavBar = (props: { items: IHeaderContentItems }) => {
    return (
        <nav className="navbar-default navbar-colored">
            <div className="container">
                <div className="row">
                    <HeaderMainNavigation items={props.items} />
                </div>
            </div>
        </nav>
    );
};
